export default __webpack_public_path__ + "static/media/delete_ico.dce05610.svg";